// Pull in template as a string by using webpack html-loader(html!)
var containerHtml = require("html!./myAccount.html");
var template = require("html!./template.html");
var templating = require("spscript").templating;

var api = require("./data");
var $ = require("jquery");

var selectors = {
	container: "#natp-myaccount",
	trigger: "#myaccount-trigger"
};
var create = function(containerSelector) {
	containerSelector = containerSelector || selectors.container;
	var actions = {
		close: () => {
			$(selectors.container).removeClass("open")
					.parent()
						.removeClass("open")
					.find("i.fa")
						.removeClass("fa-chevron-down")
						.addClass("fa-chevron-right");
		},
		open: () => {
			$(selectors.container).addClass("open")
				.parent()
					.addClass("open")
				.find("i.fa")
					.removeClass("fa-chevron-right")
					.addClass("fa-chevron-down");
				
		}
	};
	var component = { actions, $container: $(containerSelector) };

	// Render "loading" link that will be overwritten when query comes back
	component.linkGroups = [{ links: { Display: "Loading...", URL: "#" } }];

	component.init = function() {
		component.renderContainer();
		component.render();

		$(selectors.trigger).on("click", function(e) {
			e.stopPropagation();
			$(document).trigger("header-section-toggle", component);
		});
		api.getLinks().then(linkGroups => {
			component.linkGroups = linkGroups;
			component.render();
		});
		api.getName().then(n => $("#myaccount-greeting").text(`Hi, ${n}`));
	};

	// Render component container
	component.renderContainer = function() {
		component.$container.html(containerHtml);
		// component.$container = $(selectors.container);
	};

	// Render component links
	component.render = function() {
		var myAccountContainer = document.querySelector("#natp-login-myAccountLinks");
		var html = templating.render(template, component);

		if (myAccountContainer) {
			myAccountContainer.innerHTML = html;
		}
	};

	component.init();
	return component;
};

module.exports = { create: create };



// WEBPACK FOOTER //
// ./src/scripts/components/myAccount/index.js